export default "__VITE_ASSET__BqAhSzC5__"